import { ApiAlert } from "src/api/types";
import Link from "src/components/Link";
import withTranslation, {
	Translation,
} from "src/components/hoc/withTranslation";

interface AlertListDescriptionProps extends Translation {
	alert: ApiAlert;
}

const AlertListDescription = ({ t, alert }: AlertListDescriptionProps) => {
	if (alert?.object?.url?.domain === "webapp") {
		return (
			<Link className="alert-link" to={alert.object.url.path}>
				<p dangerouslySetInnerHTML={{ __html: alert.description }}></p>
			</Link>
		);
	}

	return <p dangerouslySetInnerHTML={{ __html: alert.description }}></p>;
};

AlertListDescription.locale = {
	nl: {},
	en: {},
};

export default withTranslation(AlertListDescription);
